import { useTranslation } from "react-i18next";
import CouponTabDetail from "../components/coupon-tab-detail";
import { CouponStatus, CouponType } from "../constant/index";
import { useTabStore } from "@/pages/desktop-coupon/store/tab-store";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { URLSearchParamsHelper } from "project-config/utils/url-search";

export function useGetTabsList() {
  const { t } = useTranslation("coupon");
  const { t: desktopT } = useTranslation("desktop");
  const { currentTab, setCurrentTab, setCurrentStatus, setActiveKey } =
    useTabStore();
  const location = useLocation();

  useEffect(() => {
    const urlSearchParamsHelper = new URLSearchParamsHelper(location.search);
    const filter = urlSearchParamsHelper.get("filter");
    if (!filter) return;
    let activeKeyData;
    switch (filter) {
      case "desktop":
        activeKeyData = CouponType.Desktop;
        break;
      default:
        break;
    }
    setActiveKey(String(activeKeyData));
    setCurrentTab(activeKeyData ?? CouponType.Desktop);
  }, [location, setCurrentTab, setActiveKey]);

  const currentTabsList = [
    {
      label: desktopT("tablist_desktop_coupon"),
      key: String(CouponType.Desktop),
      children: <CouponTabDetail currentTab={currentTab} />,
      visible: true,
    },
  ];

  const couponStatusList = [
    {
      label: t("coupon_status_all"),
      value: CouponStatus.All,
    },
    {
      label: t("coupon_status_use"),
      value: CouponStatus.BeUsable,
    },
    {
      label: t("coupon_status_timeout"),
      value: CouponStatus.Expired,
    },
  ];

  return {
    tabsList: currentTabsList.filter((p) => p.visible),
    setCurrentTab,
    couponStatusList,
    setCurrentStatus,
    currentTab,
  };
}
